import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Impressum() {
  const { t, i18n } = useTranslation()

  const changeLang = (lng) => i18n.changeLanguage(lng)

  return (
    <section className="section">
      {/* HEADER */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-tr from-emerald-400/10 via-fuchsia-400/10 to-sky-400/10 blur-2xl" />
        <div className="relative container mx-auto px-4 pt-10 pb-6 max-w-6xl">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">
                {t('impressum.title')}
              </h1>
              <p className="mt-2 inline-flex items-center gap-2 text-sm text-muted-foreground">
                <span className="inline-flex items-center rounded-full bg-emerald-600/10 text-emerald-700 dark:text-emerald-300 px-2.5 py-1 text-xs font-medium border border-emerald-600/20">
                  {badgeIcon()}
                  <span className="ml-1">{t('impressum.lastUpdated')}</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CONTENU */}
      <div className="container mx-auto px-4 pb-16 max-w-4xl">
        <div className="rounded-2xl border bg-card shadow-sm overflow-hidden">
          <div className="h-2 bg-gradient-to-r from-emerald-500 via-sky-500 to-fuchsia-500" />
          <div className="p-6 md:p-10 space-y-8">

            <div>
              <h2 className="text-xl font-semibold mb-2">{t('impressum.company')}</h2>
              <p>
                B-Linio GmbH<br />
                Weihergasse 15<br />
                67547 Worms<br />
                Deutschland (Allemagne)
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">{t('impressum.representative')}</h2>
              <p>Herve Mbatchou Njimi</p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">{t('impressum.contact')}</h2>
              <p>
                E-Mail : locapiol2025@gmail.com<br />
                Telefon : +49 176 47138157
              </p>
            </div>

            {/* <div>
              <h2 className="text-xl font-semibold mb-2">{t('impressum.register')}</h2>
              <p>
                Handelsregister : Amtsgericht Worms<br />
                Registernummer : HRB 12345
              </p>
            </div> */}

            <div>
              <h2 className="text-xl font-semibold mb-2">{t('impressum.vat')}</h2>
              <p>USt-IdNr. : DE123456789</p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">{t('impressum.disclaimer')}</h2>
              <p className="text-[15px] leading-relaxed"> {t('impressum.disclaimerText')} </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">{t('impressum.dispute')}</h2>
              <p className="text-[15px] leading-relaxed">
                {t( 'impressum.disputeText' )} </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

function badgeIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.9L18.18 22 12 18.77 5.82 22 7 14.17l-5-4.9 6.91-1.01L12 2z"
        fill="currentColor"
      />
    </svg>
  )
}
